module.exports = __webpack_public_path__ + "img/Bookit-logo.9d08b149.svg";